import type { ContactEmailKind, PublicAppConfig } from "~~/types/publicConfig";

/** Last-resort values if GET /config is unavailable (e.g. frontend deployed before the API). */
const FALLBACK_EMAILS: PublicAppConfig["emails"] = {
	business: {
		HU: "business@dreamjobs.hu",
		RO: "business@dreamjobs.ro",
	},
	hello: {
		HU: "hello@dreamjobs.hu",
		RO: "hello@dreamjobs.ro",
	},
};

export function usePublicConfigState() {
	return useState<PublicAppConfig | null>("appPublicConfig", () => null);
}

export function usePublicConfig() {
	const publicConfig = usePublicConfigState();

	const getEmail = (kind: ContactEmailKind, region?: string): string => {
		const code = (region || globalConfig.region || "HU").toUpperCase();
		return publicConfig.value?.emails?.[kind]?.[code] || FALLBACK_EMAILS[kind][code] || "";
	};

	return {
		publicConfig,
		getEmail,
	};
}
